module.exports = {
  "zones": {
    "Pacific/Norfolk": ["z", {
      "wallclock": 1443924000000,
      "format": "+11",
      "abbrev": "+11",
      "offset": 39600000,
      "posix": 1443882600000,
      "save": 0
    }, {
      "wallclock": 162957600000,
      "format": "+1130",
      "abbrev": "+1130",
      "offset": 41400000,
      "posix": 162912600000,
      "save": 0
    }, {
      "wallclock": 152071200000,
      "format": "+1230",
      "abbrev": "+1230",
      "offset": 41400000,
      "posix": 152029800000,
      "save": 3600000
    }, {
      "wallclock": -599616000000,
      "format": "+1130",
      "abbrev": "+1130",
      "offset": 41400000,
      "posix": -599656320000,
      "save": 0
    }, {
      "wallclock": -2177452800000,
      "format": "+1112",
      "abbrev": "+1112",
      "offset": 40320000,
      "posix": -2177493112000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 40312000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};